import type { escritas as pt } from '../pt-BR/escritas';
import type { Traducao } from '../Traducao';

export const escritas = {
  titulo: 'Saving to the record (Axiis)',
  camiseta: 'T-shirt',
  endereco: 'Official address',
  incompleto: 'Saved without city or state',
  status: {
    pendente: 'Pending: {{n}}',
    sucesso: 'Saved: {{n}}',
    falha: 'Failed: {{n}}',
  },
  retentar: 'Try saving again',
  confirmarRetentar:
    'Try again to save the pending and failed items to Axiis? The values are those of each person’s latest answer.',
  resultado_zero: '{{count}} saved, {{falha}} failed.',
  resultado_one: '{{count}} saved, {{falha}} failed.',
  resultado_other: '{{count}} saved, {{falha}} failed.',
} as const satisfies Traducao<typeof pt>;
